'use client';

import { createContext } from 'react';

import { ContentBlockCodeV1 } from '@/shared/api';
import { useCookie } from '@/shared/hooks';

type CodeEditorKeys = keyof ContentBlockCodeV1['value'];

type CodeTabContextProps = {
	value: CodeEditorKeys;
	saveTab: (value: CodeEditorKeys, options: Record<string, any>) => void;
};

export const CodeTabContext = createContext<CodeTabContextProps>({
	value: 'python',
	saveTab: () => {},
});

export function CodeTabProvider({ children }: React.PropsWithChildren) {
	const [value, saveTab] = useCookie<CodeEditorKeys>(
		'code-editor-tab',
		'python',
	);
	return (
		<CodeTabContext.Provider value={{ value, saveTab }}>
			{children}
		</CodeTabContext.Provider>
	);
}
